const DracoParamMain = {    
    pageDesc: `- 메인 대시보드 입니다.
- 설치 현황, 장애 사이트, 업무현황, 영업 현황, 장애 현황을 확인 할 수 있습니다.
- 설치 현황은 사이트의 RTU 설비를 상태 (정상, 장애, 미작동) 별로 지도에 Pin 으로 표현 됩니다. 
- 장애 사이트는 현재 장애 중인 현장 정보를 슬라이드 형태로 제공 하며 클릭시 설치 현황 지도에 위치를 확인 할 수 있습니다.
- 업무현황은 요청, 진행, 완료, 취소 상태별 건수를 표현 합니다.
- 영업 현황은 제품(RTU) 판매 현황을 그래프로 제공 합니다.
- 장애현황은 장애 카테고리별 장애건수를 전일 과 금일을 비교하여 그래프로 표현 합니다.`,

    fewShot: "",
    
    tags:[]
}

export default DracoParamMain;